export default __webpack_public_path__ + "static/media/Arçelik_Bayi_Çalışanı_Yetkilisi_Aydınlatma_Metni.e2388363.pdf";